import { render, staticRenderFns } from "./SpinnerButton.vue?vue&type=template&id=24fc16dd&scoped=true&"
import script from "./SpinnerButton.vue?vue&type=script&lang=ts&"
export * from "./SpinnerButton.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerButton.vue?vue&type=style&index=0&id=24fc16dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc16dd",
  null
  
)

export default component.exports